// extracted by mini-css-extract-plugin
export default {"registerTenantPage":"RegisterTenantPage_registerTenantPage__+cuiT"};